import { auth, isAdmin, isUser } from "@/router/auth";
import { NavigationGuardNext, Route, RouteConfig } from "vue-router";

const routes: Array<RouteConfig> = [{
                path: '/',
                beforeEnter : async (to: Route, from: Route, next: NavigationGuardNext) => {
                    await auth();
                    if (isUser() || isAdmin()){
                      next();
                    } else {
                      next('/login?next='+to.fullPath);
                    }
                },
                component: () => import(/* webpackChunkName: "user-dashboard" */ '../views/Dashboard.vue'),
                children: [
                  {
                    path: '',
                    redirect: 'shops'
                  }, {
                        path: 'shops',
                        name: 'user-shops',
                        component: () => import(/* webpackChunkName: "tayeh-prices" */ '../views/DashboardShops.vue')
                  }, {
                    path: 'support',
                    name: 'user-support',
                    component: () => import(/* webpackChunkName: "user-support" */ '../views/DashboardSupport.vue')
                  }, {
                    path: 'support/ticket/:ticket_id',
                    name: 'support-ticket',
                    component: () => import(/* webpackChunkName: "support-ticket" */ '../views/SupportTicket.vue'),
                  }, {
                    path: 'reset-password',
                    name: 'reset-password',
                    component: () => import(/* webpackChunkName: "reset-password" */ '../views/DashbaordResetPassword.vue'),
                  }, {
                    path: 'profile',
                    name: 'profile',
                    component: () => import(/* webpackChunkName: "profile" */ '../views/DashboardProfile.vue'),
                  }
                ]
        },
]

export default routes;